<template>

  <!-- General User Meta -->
  <user-meta v-if="this.$route.params.area === 'user-meta'"></user-meta>

  <!-- Big Idea -->
  <big-idea v-else-if="this.$route.params.area === 'big-idea'"></big-idea>

  <!-- Focus Areas -->
  <focus-areas v-else-if="this.$route.params.area === 'focus-areas'"></focus-areas>

</template>

<script>
import BigIdea from '@/pages/edit-profile/BigIdea'
import UserMeta from '@/pages/edit-profile/UserMeta'
import FocusAreas from '@/pages/edit-profile/FocusAreas'

export default {
  components: {
    BigIdea,
    UserMeta,
    FocusAreas
  }
}
</script>



// WEBPACK FOOTER //
// EditProfile.vue?6a19d5b4